// extracted by mini-css-extract-plugin
module.exports = {"section_flex":"UniverseMembers_section_flex__z_wUl","expand":"UniverseMembers_expand__j8Dfm"};